import { NOTIFICATIONS_APP_NAME } from "Shared/Types/notifications";
import {
  CONTACTS,
  EQUIPMENTS,
  FUEL_HISTORY,
  INSPECTIONS_HISTORY,
  ISSUES,
  PARTS,
  PURCHASE_ORDERS,
  REMINDERS_SERVICES,
  REPORTS,
  SERVICE_HISTORY,
  SETTINGS_GENERAL_SETTING_BILLING,
  UNITS,
  VENDORS,
  WORK_ORDERS,
} from "./routes";

export const NOTIFICATIONS_ROUTE: Record<NOTIFICATIONS_APP_NAME, string> = {
  [NOTIFICATIONS_APP_NAME.Parts]: PARTS,
  [NOTIFICATIONS_APP_NAME.Contacts]: CONTACTS,
  [NOTIFICATIONS_APP_NAME.Inspection]: INSPECTIONS_HISTORY,
  [NOTIFICATIONS_APP_NAME.Fuel]: FUEL_HISTORY,
  [NOTIFICATIONS_APP_NAME.Vehicles]: UNITS,
  [NOTIFICATIONS_APP_NAME.Work_orders]: WORK_ORDERS,
  [NOTIFICATIONS_APP_NAME.Purchase_order]: PURCHASE_ORDERS,
  [NOTIFICATIONS_APP_NAME.Reports]: REPORTS,
  [NOTIFICATIONS_APP_NAME.Reminders]: REMINDERS_SERVICES,
  [NOTIFICATIONS_APP_NAME.Issues]: ISSUES,
  [NOTIFICATIONS_APP_NAME.Billing]: SETTINGS_GENERAL_SETTING_BILLING,
  [NOTIFICATIONS_APP_NAME.Service_entry]: SERVICE_HISTORY,
  [NOTIFICATIONS_APP_NAME.Inventory]: EQUIPMENTS,
  [NOTIFICATIONS_APP_NAME.Vendors]: VENDORS,
};

// Notification actions are in-app destinations. Reject schemes and other origins.
export const getNotificationRoute = (
  notification: {
    action_url?: string | null;
    app_name: NOTIFICATIONS_APP_NAME;
    data?: unknown;
  },
  origin: string = window.location.origin,
): string | undefined => {
  const action = notification.action_url?.trim();
  if (action && (action.startsWith("/") || /^https?:\/\//i.test(action))) {
    try {
      const url = new URL(action, origin);
      if (url.origin === origin) {
        let data = notification.data;
        if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch {
            data = null;
          }
        }
        const serviceId =
          data && typeof data === "object" && "reminder_id" in data
            ? (data as { reminder_id?: unknown }).reminder_id
            : undefined;
        if (
          /^\/reminders\/services\/?$/.test(url.pathname) &&
          typeof serviceId === "string"
        ) {
          url.pathname = `/reminders/services/${encodeURIComponent(serviceId)}`;
        }
        const renewalPath = url.pathname.match(
          /^\/reminders\/(vehicles|contacts)(?:\/([^/]+))?\/?$/,
        );
        if (renewalPath) {
          // Vehicle/contact renewals use detail panels on their list routes.
          const dataId =
            data && typeof data === "object" && "reminder_id" in data
              ? (data as { reminder_id?: unknown }).reminder_id
              : undefined;
          const pathId = renewalPath[2];
          const isRecordPath =
            pathId && !["add", "create", "edit"].includes(pathId);
          const reminderId =
            url.searchParams.get("reminder") ||
            (isRecordPath ? pathId : undefined) ||
            (typeof dataId === "string" ? dataId : undefined);
          if (reminderId && (!pathId || isRecordPath)) {
            url.pathname = `/reminders/${renewalPath[1]}`;
            url.searchParams.set("reminder", reminderId);
          }
        }
        return `${url.pathname}${url.search}${url.hash}`;
      }
    } catch {
      /* Use the module destination for malformed links. */
    }
  }
  return NOTIFICATIONS_ROUTE[notification.app_name];
};
